import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { Store } from '@ngrx/store';

import { Question } from '../../shared/question.model';
import * as QuestionListActions from '../store/question-list.actions';
import * as fromApp from '../../store/app.reducers';
// import * as EventActions from '../../events/store/event.actions';

@Component({
  selector: 'app-question-edit',
  templateUrl: './question-edit.component.html',
  styleUrls: ['./question-edit.component.css']
})
export class QuestionEditComponent implements OnInit, OnDestroy {
  @ViewChild('f') slForm: NgForm;
  subscription: Subscription;
  editMode = false;
  editedItem: Question;

  constructor(private store: Store<fromApp.AppState>) { }

  ngOnInit() {
    this.subscription = this.store.select('questionList')
      .subscribe(
        data => {
          if (data.editedQuestionIndex > -1) {
            this.editedItem = data.editedQuestion;
            this.editMode = true;
            this.slForm.setValue({
              name: this.editedItem.name,
              text: this.editedItem.text,
              type: this.editedItem.type
            })
          } else {
            this.editMode = false;
          }
        }
      );
  }

  onSubmit(form: NgForm) {
    const value = form.value;
    const newQuestion = new Question('id100', value.name, value.text, value.type, 0, 0, false);
    if (this.editMode) {
      this.store.dispatch(new QuestionListActions.UpdateQuestion({question: newQuestion}));
      this.store.dispatch(new QuestionListActions.StoreQuestions());

    } else {
      this.store.dispatch(new QuestionListActions.AddQuestion(newQuestion));

    }
    this.editMode = false;
    form.reset();
  }

  onClear() {
    this.slForm.reset();
    this.editMode = false;
  }

  onDelete() {
    this.store.dispatch(new QuestionListActions.DeleteQuestion());
    this.onClear();
  }

  ngOnDestroy() {
    this.store.dispatch(new QuestionListActions.StopEdit());
    this.subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/question-list/question-edit/question-edit.component.ts